import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge } from 'rxjs';
import { map, debounceTime, filter, distinct } from 'rxjs/operators';
declare let $: any;

@Injectable()
export class DatasScrollService {
    private onLoadFirstPage$ = new BehaviorSubject(1);
    public pageNumber = 1;
    public numberOfItems = 6;

    public constructor() { }

    /**
     * Scroll event - Check if loading-spinner is in viewport
     */
    public pageByScroll$ = fromEvent(window, 'scroll').pipe(
        map(() => window.scrollTo(0,0)),
        filter(function(current) {
            const element = document.querySelector('loading-spinner');
            if (typeof current == 'number' && element && element instanceof HTMLElement) {
                return current >= ( element.offsetTop - window.innerHeight)
            } else {
                return false;
            }
        }),
        distinct(),
        debounceTime(200),
        map(() => {
            // Should be keep separate like this, returning incremented value doesn't work properly with debounceTime
            this.pageNumber++;
            return this.pageNumber;
        })
    );

    public pageToLoad$ = merge(this.onLoadFirstPage$, this.pageByScroll$).pipe(
        distinct()
    );

    public backToTopScroll$ = fromEvent(window, 'scroll').pipe(
        debounceTime(500),
        map(() => window.scrollY)
    );

    public getNumberOfItems() {
        return this.numberOfItems;
    }
}
